/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    const loginTime = localStorage.getItem('admin_login_time');

    if (token && loginTime) {
      const sessionDuration = 24 * 60 * 60 * 1000;
      const currentTime = Date.now();
      const timeSinceLogin = currentTime - parseInt(loginTime, 10);

      if (timeSinceLogin < sessionDuration) {
        setIsAuthenticated(true);
      } else {
        handleLogout();
      }
    }

    setIsChecking(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_login_time');
    setIsAuthenticated(false);
  };

  if (isChecking) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center relative overflow-hidden">
        <div className="absolute top-1/3 -right-32 w-[400px] h-[400px] bg-orange-500/10 rounded-full blur-[120px] pointer-events-none" />
        <div className="text-center relative z-10">
          <div className="w-14 h-14 border-[3px] border-orange-500/20 border-t-orange-500 rounded-full animate-spin mx-auto mb-6" />
          <p className="text-white text-lg font-semibold">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return React.cloneElement(children, { onLogout: handleLogout });
};

export default ProtectedRoute;
